import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
type PlanType = 'implementacion' | 'control-total' | 'base';
export function PricingSelector() {
  const [selectedPlan, setSelectedPlan] = useState<PlanType>('control-total');
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="max-w-3xl mx-auto my-24" data-id="element-451">
      <div className="text-center mb-10" data-id="element-452">
        <h2 className="text-3xl md:text-4xl font-extrabold text-emerald-500 mb-4" data-id="element-453">
          ELEGÍ TU OPCIÓN
        </h2>
        <p className="text-xl text-slate-300" data-id="element-454">
          Seleccioná el pack que mejor se adapte a tu empresa.
        </p>
      </div>

      <div className="space-y-4 bg-slate-900/50 p-4 md:p-8 rounded-2xl border border-slate-800" data-id="element-455">
        {/* Card 1: Pack Implementación */}
        <div className={`relative p-5 md:p-6 rounded-xl cursor-pointer transition-all duration-300 flex items-start gap-4 ${selectedPlan === 'implementacion' ? 'border-2 border-emerald-500 bg-slate-800/80 shadow-[0_0_30px_rgba(34,197,94,0.15)]' : 'border border-slate-700 bg-slate-900/80 hover:border-slate-500'}`} onClick={() => setSelectedPlan('implementacion')} data-id="element-456">
          <div className="mt-1 flex-shrink-0" data-id="element-457">
            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'implementacion' ? 'border-emerald-500' : 'border-slate-500'}`} data-id="element-458">
              {selectedPlan === 'implementacion' && <div className="w-3 h-3 rounded-full bg-emerald-500" data-id="element-459" />}
            </div>
          </div>
          <div className="flex-grow" data-id="element-460">
            <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-2 mb-2" data-id="element-461">
              <div data-id="element-462">
                <h3 className="text-xl font-bold text-white flex items-center gap-2" data-id="element-463">
                  <span data-id="element-464">🥈</span> PACK IMPLEMENTACIÓN
                </h3>
              </div>
              <div className="text-left md:text-right" data-id="element-465">
                <p className="text-slate-500 line-through text-sm" data-id="element-466">$55.000</p>
                <p className="text-3xl font-extrabold text-emerald-400" data-id="element-467">
                  $29.990
                </p>
              </div>
            </div>
            <p className="text-slate-300 font-medium mb-3" data-id="element-468">
              6 Tomos + 3 Bonos + Execution Toolkit
            </p>
            <ul className="text-sm text-slate-400 space-y-1" data-id="element-469">
              <li data-id="element-470">+ Plan de Implementación 30 Días</li>
              <li data-id="element-471">+ Kit de Reclutamiento</li>
              <li data-id="element-472">+ SOPs y Perfiles de Puesto</li>
            </ul>
          </div>
        </div>

        {/* Card 2: Pack Control Total */}
        <div className={`relative p-5 md:p-6 rounded-xl cursor-pointer transition-all duration-300 flex items-start gap-4 ${selectedPlan === 'control-total' ? 'border-2 border-emerald-500 bg-slate-800/80 shadow-[0_0_30px_rgba(34,197,94,0.15)]' : 'border border-slate-700 bg-slate-900/80 hover:border-slate-500'}`} onClick={() => setSelectedPlan('control-total')} data-id="element-473">
          <div className="mt-1 flex-shrink-0" data-id="element-474">
            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'control-total' ? 'border-emerald-500' : 'border-slate-500'}`} data-id="element-475">
              {selectedPlan === 'control-total' && <div className="w-3 h-3 rounded-full bg-emerald-500" data-id="element-476" />}
            </div>
          </div>
          <div className="flex-grow" data-id="element-477">
            <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-2 mb-2" data-id="element-478">
              <div data-id="element-479">
                <h3 className="text-xl font-bold text-white flex items-center gap-2" data-id="element-480">
                  <span data-id="element-481">🥇</span> PACK CONTROL TOTAL
                </h3>
                <div className="flex flex-wrap gap-2 mt-2" data-id="element-482">
                  <span className="bg-emerald-500 text-white px-2 py-0.5 rounded text-xs font-bold flex items-center gap-1" data-id="element-483">
                    <StarIcon className="w-3 h-3 fill-current" data-id="element-484" /> MÁS ELEGIDO
                  </span>
                  <span className="border border-emerald-500 text-emerald-400 px-2 py-0.5 rounded text-xs font-bold" data-id="element-485">
                    AHORRAS $35.010
                  </span>
                </div>
              </div>
              <div className="text-left md:text-right mt-2 md:mt-0" data-id="element-486">
                <p className="text-slate-500 line-through text-sm" data-id="element-487">$75.000</p>
                <p className="text-3xl font-extrabold text-emerald-400" data-id="element-488">
                  $39.990
                </p>
              </div>
            </div>
            <p className="text-slate-300 font-medium mb-3" data-id="element-489">
              6 Tomos + 3 Bonos + Execution Toolkit + Governance System
            </p>
            <ul className="text-sm text-slate-400 space-y-1" data-id="element-490">
              <li data-id="element-491">+ Tablero de KPIs</li>
              <li data-id="element-492">+ Gestión de Proyectos Ágil</li>
              <li data-id="element-493">+ Protocolo de Reuniones</li>
              <li data-id="element-494">+ Matriz de Riesgos</li>
            </ul>
          </div>
        </div>

        {/* Card 3: Pack Base */}
        <div className={`relative p-5 md:p-6 rounded-xl cursor-pointer transition-all duration-300 flex items-start gap-4 ${selectedPlan === 'base' ? 'border-2 border-emerald-500 bg-slate-800/80 shadow-[0_0_30px_rgba(34,197,94,0.15)]' : 'border border-slate-700 bg-slate-900/80 hover:border-slate-500'}`} onClick={() => setSelectedPlan('base')} data-id="element-495">
          <div className="mt-1 flex-shrink-0" data-id="element-496">
            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'base' ? 'border-emerald-500' : 'border-slate-500'}`} data-id="element-497">
              {selectedPlan === 'base' && <div className="w-3 h-3 rounded-full bg-emerald-500" data-id="element-498" />}
            </div>
          </div>
          <div className="flex-grow" data-id="element-499">
            <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-2 mb-2" data-id="element-500">
              <div data-id="element-501">
                <h3 className="text-xl font-bold text-white flex items-center gap-2" data-id="element-502">
                  <span data-id="element-503">🥉</span> PACK BASE
                </h3>
              </div>
              <div className="text-left md:text-right" data-id="element-504">
                <p className="text-slate-500 line-through text-sm" data-id="element-505">$35.000</p>
                <p className="text-3xl font-extrabold text-emerald-400" data-id="element-506">
                  $19.990
                </p>
              </div>
            </div>
            <p className="text-slate-300 font-medium" data-id="element-507">6 Tomos + 3 Bonos</p>
          </div>
        </div>

        {/* CTA Button */}
        <div className="mt-8 pt-4" data-id="element-508">
          <a href={selectedPlan === 'base' ? 'https://fegion.shop/cart/46195221364875:1' : selectedPlan === 'implementacion' ? 'https://fegion.shop/cart/46195232702603:1' : 'https://fegion.shop/cart/46195236503691:1'} className="w-full bg-emerald-500 hover:bg-emerald-400 text-slate-900 font-extrabold text-lg py-4 px-6 rounded-lg transition-colors shadow-lg shadow-emerald-500/20 block text-center" data-id="element-509">
            {selectedPlan === 'implementacion' && '💚 QUIERO EL PACK IMPLEMENTACIÓN — $29.990'}
            {selectedPlan === 'control-total' && '💚 QUIERO EL PACK CONTROL TOTAL — $39.990'}
            {selectedPlan === 'base' && '💚 QUIERO EL PACK BASE — $19.990'}
          </a>
        </div>
      </div>
    </motion.div>;
}